<ng-template #sendToAccountModal>
    <div id="sendToAccountCard" class="card sendToAccount" dir={{direction}}>
        <div id="sendToAccountClose" (click)="dismiss()" class="close_icon">
        </div>
        <div id="sendToAccountBody" class="modal-body">
        <div id="sendToAccountSuccess" *ngIf="sendToStoreSuccess" class="success_img_div">
            <span class="success_img"></span>
          </div>
        <div id="sendToSegmentHeader" class="send-to-segment-account-header">
            <span *ngIf="!sendToStoreSuccess" i18n="@@send-to-segment-account-send-name">Send {{sendName}}</span>
            <span *ngIf="sendToStoreSuccess" class="sent-success-msg" i18n="@@send-to-segment-account.has-been-sent-label">{{sendName}} has been sent</span>
        </div>
        <div id="sendToSegmentSubHeader" class="send-to-segment-sub-heading" *ngIf="!sendToStoreSuccess">
            <span i18n="@@send-to-segment-account.select-store-to-send-label">Select the stores where you would like to send {{sendName}}</span>
        </div>
        <div id="sendToSegmentSearchHeader" class="search_header" *ngIf="!sendToStoreSuccess">
            <div id="sendToSegmentSearchInput" class="input-group">
                <input #searchValue type="search" #searchValue placeholder="{{searchPlaceholderText}}" class="sendToStoreSearchBx"
                [(ngModel)]="searchData" (keyup.enter)="filterData('storenamesearch',searchData)" (ngModelChange)="clearFilters('storenamesearch')" />
            </div>
            <button type="button" class="btn btn-primary ml-2 search_btn" (click) = "filterData('storenamesearch',searchData)">
                <img class="search_class" alt="search" />
            </button>
            <span class="button_right">
                
                <select #drop2 (change)="filterData('countryfilter', drop2.value)" class="btn-greyscale btn-sm dropdown-toggle select-bx-state-country"
                aria-haspopup="true" aria-expanded="false" *ngIf="!this.filters.countryData">
                <option selected default class="option-default"><span i18n="@@stores.store-user.location">Location</span></option>
                <option class="dropdown-item" *ngFor="let data of countryList" [value]="data">
                  {{ data }}
                </option>
              </select>
              <div id="sendToSegmentDropDown" class="dropdown-selected" *ngIf="this.filters.countryData">{{this.filters.countryData}}
                <img class="dropdown-selected-img" (click)="clearFilters('countryfilter')" alt="close" />
              </div>
              &nbsp;&nbsp;
              <select #drop3 (change)="filterData('stateRegionProvincefilter', drop3.value)" class="btn-greyscale btn-sm dropdown-toggle select-bx-state-country"
                aria-haspopup="true" aria-expanded="false" *ngIf="!this.filters.stateData">
                <option selected default class="option-default"><span i18n="@@stores.store-user.state-province-regions">State/Province/Regions</span>
                </option>
                <option class="dropdown-item" *ngFor="let data of stateProvinceList" [value]="data">
                  {{ data }}
                </option>
              </select>
              <div id="sendToSegmentDropDownSelected" class="dropdown-selected" *ngIf="this.filters.stateData">{{this.filters.stateData}}
                <img class="dropdown-selected-img" (click)="clearFilters('stateRegionProvincefilter')" alt="close" />
              </div>

            </span>
        </div>
        <div id="sendStoreTableSection" class="sendStoreTableSection" *ngIf="!sendToStoreSuccess">
            <table id="sendStoreTable" class="table table-borderless table-responsive" aria-describedby="list of store">
                <colgroup>
                    <col span="4" />
                    <col span="3" id="last_3_cols" />
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">
                            <span class="table_headings">
                                <input class="" type="checkbox" name="list_name" value="" [checked]="this.isSelected.size === this.totalPages && this.isSelected.size" [disabled]='!this.totalPages'
                                    (change)="isStoreSelectAll()" />
                            </span>
                        </th>
                        <th scope="col">{{storeNameHeading}}</th>
                        <th scope="col">{{storeNumberHeading}}</th>
                        <th scope="col">{{storeIDHeading}}</th>
                        <th scope="col">{{stateHeading}}</th>
                        <th scope="col">{{countryHeading}}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container
                        *ngFor="let data of displayStoresData">
                        <tr>
                            <td>
                                <input type="checkbox" name="list_name" (change)="selectedData(data)"
                                    [checked]="this.isSelected.has(data.storeId)" />
                            </td>
                            <td>{{ data?.storeName }}</td>
                            <td>{{ data?.storeNumber }}</td>
                            <td>{{ data?.storeId }}</td>
                            <td>{{ data?.stateRegionProvince }}</td>
                            <td>{{ data?.country }}</td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
            <div class="center-text" *ngIf="!displayStoresData?.length">
            <span class="center-text" *ngIf='!isLoading && isStoreDataEmpty; else loading'>{{noRecordFound}}</span>
            <ng-template #loading>
               <div class="center-text">{{loadingText}}</div>
            </ng-template>
            </div>
        </div>
        <!--Pagination-->
        <div id="sendToStorePagination" class="pagination_end" *ngIf="!sendToStoreSuccess && storesData?.length">
            <nav aria-label="existing profiles pagination">
                <ngb-pagination class="d-flex justify-content-center" [collectionSize]="paginationCount" [(page)]="page" [pageSize]="10"
                [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
                (pageChange)="onTableDataChange($event)"></ngb-pagination>
            </nav>
            <div id="sendToStoreSubTitle" class="send_store_subtitle mt-2"><span i18n="@@send-to-segment-account-store-seleted-count">{{isSelected.size}} stores selected</span></div>
        </div>
    </div>
        <div id="sendToStoreFooter" class="modal-footer send-to-segment-account-footer" *ngIf="!sendToStoreSuccess">
            <button type="button" (click)="dismiss()" class="btn btn-outline-primary gtmCancelDltContGrp">
                <span>{{cancelButtonText}}</span>
            </button>
            <button type="button" class="btn btn-primary gtmDeleteContGrp" (click)="onAdd()" [disabled]="!isSelected.size">
                <span>{{sendButtonName}}</span>
            </button>
        </div>
    </div>
</ng-template>